
import { defineComponent } from "vue"
import ProductGiftRecordsIndex from "@/components/product_gift_records/Index.vue"

export default defineComponent({
  components: {
    ProductGiftRecordsIndex
  }
})
